import React, { useEffect, useState, useRef } from 'react'
import axios from '../../API/axios';
import { Link, Navigate, useLocation, useNavigate, useParams } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import AttachEmailSharpIcon from '@mui/icons-material/AttachEmailSharp';
import CalendarMonthSharpIcon from '@mui/icons-material/CalendarMonthSharp';
import LanguageSharpIcon from '@mui/icons-material/LanguageSharp';
import Checkbtn from './Checkbtn';
import jsPDF from 'jspdf';
import ResumePdf from '../Resume/ResumePdf';
import { createRoot } from "react-dom/client";
import html2canvas from 'html2canvas';
import LinkSharpIcon from '@mui/icons-material/LinkSharp';
import WcSharpIcon from '@mui/icons-material/WcSharp';
import error from "../../assets/images/Not-Found.png";
// import html2pdf from "html2pdf.js";

import moment from 'moment';
import toast from 'react-hot-toast';

const CandidateResume = () => {

	const sessionId = localStorage.getItem("sessionId");
	const UserType = localStorage.getItem("userType");
	const userInstUID = localStorage.getItem("userUID")
	const instnUID = localStorage.getItem("userUID");
	const { CandidateId } = useParams();
	const { userUid } = useParams();
	const { insttId } = useParams();

	console.log("userUID===>", userInstUID)
	//  *******************************     RESUME LISTING   ************************************************

	const [userEducation, setUserEducation] = useState([]);
	const [userAwards, setUserAwards] = useState([]);
	const [userExperience, setUserExperience] = useState([]);
	const [userCertification, setUserCertification] = useState([]);
	const [userDataInfo, setUserDataInfo] = useState([]);
	const [resumeStatus, setResumeStatus] = useState("");
	console.log("userDataInfo", userCertification);
	const [projectData, setProjectData] = useState([]);
	const [userSkill, setUserSkill] = useState([]);
	const [isError, setIsError] = useState(false);
	console.log("User SKills===>", userSkill)
	const [userEduActivity, setUserEduActivity] = useState([]);
	const [userEduAchievements, setUserEduAchievements] = useState([]);
	const [userExpRole, setUserExpRole] = useState([]);
	const [userExpAchievements, setUserExpAchievements] = useState([]);

	const location = useLocation();
	const queryParams = new URLSearchParams(location.search);
	const userUID = queryParams.get('userUID');
	const InstnCnddtId = queryParams.get('InstnCnddtId');

	const navigate = useNavigate();

	const [loading, setLoading] = useState(true); // New state for loading

	const getUserCv = async () => {
		const data = {
			sessionId: sessionId,
			userUID: userUID,

			// userUID: (UserType === "Company" || UserType === "Recruiter") 
			// 	? (candidateType === "Candidate" ? userUid 
			// 		: (candidateType === "Institution" ? userUID : userUID)) 
			// 	: userUID, 

			instnCnddtId: InstnCnddtId,
		};

		console.log("data", data);
		try {
			const resData = await axios.post(`/CandidateData/Resume`, data);

			setUserDataInfo(resData.data.responseData.userDataInfo);
			setUserEducation(resData.data.responseData.educations);
			setUserExperience(resData.data.responseData.experiences);
			setUserAwards(resData.data.responseData.awards);
			setUserSkill(resData.data.responseData.skills);
			setUserCertification(resData.data.responseData.certifications);
			setProjectData(resData.data.responseData.projects);
			setResumeStatus(resData.data.message)
		} catch (error) {
			if (error.response && error.response.status === 404) {
				console.log("Error 404: Not Found");
			} else {
				console.error(error);
				setIsError(true);
			}
		} finally {
			setLoading(false);
		}
	};

	useEffect(() => {
		getUserCv();
	}, []);

	const handleClick = (e) => {
		if (userInstUID !== userDataInfo?.insttnUID) {
			e.preventDefault();
			toast.error("You are not authorized to manage this resume.");
		} else {
			navigate(`/Resume/${InstnCnddtId || "Candidate"}/Manage`);
		}
	};

	// ......................................................................................................
	// ...................Filter of Enabled and Disable button of ResumeDetails Page.........................
	// ......................................................................................................

	const filteredEducation = userEducation?.filter((item) => !item.isDeleted && item.status === 1);
	const filteredExperience = userExperience?.filter((item) => !item.isDeleted && item.status === 1);
	const filteredCertification = userCertification?.filter((item) => !item.isDeleted && item.status === 1);
	const filteredAwards = userAwards?.filter((item) => !item.isDeleted && item.status === 1);
	const filtereprojectData = projectData?.filter((item) => !item.isDeleted && item.status === 1);

	console.log("filteredEducation", filteredEducation, filteredExperience, filteredCertification, filteredAwards, filtereprojectData);

	// ......................................................................................................
	// ...................Filter of Enabled and Disable button of ResumeDetails Page.........................
	// ......................................................................................................


	//  *******************************    RESUME LISTING  ************************************************

	const [isDownloading, setIsDownloading] = useState(false);
	const isDownloadingRef = useRef(false); // Ref to track download state

	// const downloadResume = async () => {
	// 	if (isDownloadingRef.current) return; // Prevent multiple clicks

	// 	setIsDownloading(true);
	// 	isDownloadingRef.current = true; // Lock further clicks

	// 	let tempContainer = null;
	// 	let root = null;

	// 	try {
	// 		tempContainer = document.createElement("div");
	// 		tempContainer.style.position = "absolute";
	// 		tempContainer.style.left = "-9999px";
	// 		document.body.appendChild(tempContainer);

	// 		root = createRoot(tempContainer);
	// 		root.render(
	// 			<ResumePdf
	// 				userDataInfo={userDataInfo}
	// 				userExperience={userExperience}
	// 				userAwards={userAwards}
	// 				userCertification={userCertification}
	// 				userEducation={userEducation}
	// 				projectData={projectData}
	// 				userSkill={userSkill}
	// 			/>
	// 		);

	// 		await new Promise((resolve) => setTimeout(resolve, 1500));

	// 		const sections = tempContainer.querySelectorAll(".pdf-section");
	// 		const pdf = new jsPDF("portrait", "pt", "a4");
	// 		const pdfWidth = pdf.internal.pageSize.getWidth() - 40;
	// 		const pdfHeight = pdf.internal.pageSize.getHeight() - 40;
	// 		let currentY = 20;

	// 		pdf.setLineHeightFactor(1.5);

	// 		for (let i = 0; i < sections.length; i++) {
	// 			const section = sections[i];

	// 			section.querySelectorAll("ul, ol").forEach((list) => {
	// 				list.style.paddingLeft = "20px";
	// 				list.style.paddingBottom = "4px";
	// 				list.style.listStylePosition = "inside";
	// 			});

	// 			const sectionCanvas = await html2canvas(section, {
	// 				scrollY: 0,
	// 				scale: 3,
	// 				useCORS: true,
	// 			});

	// 			const sectionHeight = (sectionCanvas.height * pdfWidth) / sectionCanvas.width;

	// 			if (currentY + sectionHeight > pdfHeight) {
	// 				pdf.addPage();
	// 				currentY = 20;
	// 			}

	// 			pdf.addImage(
	// 				sectionCanvas.toDataURL("image/png"),
	// 				"PNG",
	// 				20,
	// 				currentY,
	// 				pdfWidth,
	// 				sectionHeight
	// 			);
	// 			currentY += sectionHeight + 10;
	// 		}

	// 		const userName = userDataInfo?.fullName || "Resume";
	// 		const fileName = `${userName} Resume.pdf`;
	// 		pdf.save(fileName);
	// 	} catch (error) {
	// 		console.error("Error generating ", error.message);
	// 	} finally {
	// 		if (root) {
	// 			root.unmount();
	// 		}
	// 		if (tempContainer) {
	// 			document.body.removeChild(tempContainer);
	// 		}
	// 		setIsDownloading(false);
	// 		isDownloadingRef.current = false; // Unlock button for next click
	// 	}
	// };




	// const downloadResume = async () => {
	// 	adjustSectionsForPageBreak(); // Ensure proper page breaks
	// 	let tempContainer = null;
	// 	let root = null;

	// 	try {
	// 		// Remove any existing pdfContent if it already exists
	// 		let existingPdfContent = document.getElementById("pdfContent");
	// 		if (existingPdfContent) {
	// 			existingPdfContent.remove();
	// 		}

	// 		// Create a temporary container for rendering the PDF
	// 		tempContainer = document.createElement("div");
	// 		tempContainer.style.position = "absolute";
	// 		tempContainer.style.left = "-9999px";
	// 		tempContainer.style.width = "1200px"; // Match the provided layout
	// 		document.body.appendChild(tempContainer);

	// 		// Render the ResumePdf component inside the container with CENTER ALIGNMENT
	// 		root = createRoot(tempContainer);
	// 		root.render(
	// 			<div id="pdfWrapper" style={{ display: "flex", justifyContent: "center", width: "100%" }}>
	// 				<div id="pdfContent" style={{ color: "black", width: "100%" }}>
	// 					<ResumePdf
	// 						userDataInfo={userDataInfo}
	// 						userExperience={userExperience}
	// 						userAwards={userAwards}
	// 						userCertification={userCertification}
	// 						userEducation={userEducation}
	// 						projectData={projectData}
	// 						userSkill={userSkill}
	// 					/>
	// 				</div>
	// 			</div>
	// 		);

	// 		// Wait for rendering to complete
	// 		await new Promise((resolve) => setTimeout(resolve, 2000));

	// 		// Capture the content using html2canvas
	// 		const pdfContent = tempContainer.querySelector("#pdfContent");

	// 		const canvas = await html2canvas(pdfContent, {
	// 			scale: 2, // Higher scale for better resolution
	// 			useCORS: true,
	// 			scrollY: -window.scrollY, // Ensure correct positioning
	// 			logging: true // Debugging
	// 		});

	// 		const imgData = canvas.toDataURL("image/png");
	// 		const pdf = new jsPDF("portrait", "pt", "a4");

	// 		// A4 page dimensions
	// 		const pageWidth = 595;  // A4 width in pt
	// 		const pageHeight = 842; // A4 height in pt
	// 		const paddingTopBottom = 20;
	// 		const paddingRight = 20;
	// 		const paddingLeft = 0;

	// 		// Image dimensions with adjusted padding
	// 		const imgWidth = pageWidth - paddingRight; // Reduce width by right padding only
	// 		const imgHeight = (canvas.height * imgWidth) / canvas.width; // Maintain aspect ratio

	// 		let yPosition = paddingTopBottom;

	// 		// Add pages dynamically if content is too long
	// 		while (yPosition < imgHeight) {
	// 			pdf.addImage(imgData, "PNG", paddingLeft, -yPosition + paddingTopBottom, imgWidth, imgHeight);
	// 			yPosition += pageHeight - 2 * paddingTopBottom;
	// 			if (yPosition < imgHeight) {
	// 				pdf.addPage();
	// 			}
	// 		}

	// 		// Save the PDF
	// 		const userName = userDataInfo?.fullName || "Resume";
	// 		pdf.save(`${userName}.pdf`);
	// 	} catch (error) {
	// 		console.error("Error generating PDF:", error);
	// 	} finally {
	// 		// Cleanup
	// 		if (root) root.unmount();
	// 		if (tempContainer) document.body.removeChild(tempContainer);
	// 	}
	// };


	// function adjustSectionsForPageBreak() {
	// 	const sections = document.querySelectorAll('.section');
	// 	let pageHeight = 800; // Approximate A4 page height
	// 	let currentPageHeight = 0;

	// 	sections.forEach((section, index) => {
	// 		const rect = section.getBoundingClientRect();
	// 		let sectionHeight = rect.height;

	// 		if (currentPageHeight + sectionHeight > pageHeight) {
	// 			section.style.pageBreakBefore = 'always'; // New page start
	// 			section.style.pageBreakInside = 'avoid';
	// 			section.style.paddingTop = "20px"; // Ensure spacing on new page
	// 			currentPageHeight = sectionHeight;
	// 		} else {
	// 			section.style.pageBreakBefore = 'auto';
	// 			currentPageHeight += sectionHeight;
	// 		}

	// 		console.log(`Section ${index + 1}: Height - ${sectionHeight}px, Current Page Height - ${currentPageHeight}px`);
	// 	});
	// }



	// const proxyUrl = "https://api.allorigins.win/raw?url=";
	// const imageUrl = proxyUrl + encodeURIComponent(userDataInfo.userImage);

	// fetch("https://dev-api.jobkikhoj.com/Media/ProfileImage/jpeg.jpg")
	// 	.then(res => res.blob())
	// 	.then(blob => console.log("Image fetched successfully!", blob))
	// 	.catch(err => console.error("Image fetch error:", err));


	const downloadResume = async () => {
		if (isDownloadingRef.current) return;

		setIsDownloading(true);
		isDownloadingRef.current = true;

		let tempContainer = null;
		let root = null;

		try {
			tempContainer = document.createElement("div");
			tempContainer.style.position = "absolute";
			tempContainer.style.left = "-9999px";
			document.body.appendChild(tempContainer);

			root = createRoot(tempContainer);


			let userImageBase64 = "/path/to/default-avatar.png";
			if (userDataInfo?.userImage) {
				console.log("Fetching image:", userDataInfo.userImage);
				try {
					userImageBase64 = await fetchImageAsBase64(userDataInfo.userImage);
					console.log("User image converted to Base64 successfully!");
				} catch (error) {
					console.warn("Failed to load user image: khoj", error.message);
				}
			}

			root.render(
				<div id="pdfContent" style={{ color: "black", width: "100%" }}>
					<ResumePdf
						userDataInfo={{ ...userDataInfo, userImage: userImageBase64 }}
						userExperience={userExperience}
						userAwards={userAwards}
						userCertification={userCertification}
						userEducation={userEducation}
						projectData={projectData}
						userSkill={userSkill}
					/>
				</div>
			);

			await new Promise((resolve) => setTimeout(resolve, 1500));

			const sections = tempContainer.querySelectorAll(".pdf-section");
			const pdf = new jsPDF("portrait", "pt", "a4");
			const pdfWidth = pdf.internal.pageSize.getWidth() - 40;
			const pdfHeight = pdf.internal.pageSize.getHeight() - 40;
			let currentY = 20;

			pdf.setLineHeightFactor(1.5);

			for (let i = 0; i < sections.length; i++) {
				const section = sections[i];

				section.querySelectorAll("ul, ol").forEach((list) => {
					list.style.paddingLeft = "20px";
					list.style.paddingBottom = "4px";
					list.style.listStylePosition = "inside";
				});

				try {
					const sectionCanvas = await html2canvas(section, {
						scrollY: 0,
						scale: 3,
						useCORS: true,
						taintTest: false,
					});

					const sectionHeight = (sectionCanvas.height * pdfWidth) / sectionCanvas.width;

					if (currentY + sectionHeight > pdfHeight) {
						pdf.addPage();
						currentY = 20;
					}

					const imgData = sectionCanvas.toDataURL("image/png");

					if (imgData && imgData.startsWith("data:image/png")) {
						pdf.addImage(imgData, "PNG", 20, currentY, pdfWidth, sectionHeight);
						currentY += sectionHeight + 10;
					} else {
						console.warn("Skipping invalid or corrupt image.");
					}
				} catch (imgError) {
					console.warn("Error processing image:", imgError.message);
				}
			}

			const userName = userDataInfo?.fullName || "Resume";
			const fileName = `${userName} Resume.pdf`;
			pdf.save(fileName);
		} catch (error) {
			console.error("Error generating resume: khoj", error.message);
		} finally {
			if (root) {
				root.unmount();
			}
			if (tempContainer) {
				document.body.removeChild(tempContainer);
			}
			setIsDownloading(false);
			isDownloadingRef.current = false;
		}
	};

	// Fetch Image as Base64 (Solves CORS & Fetch Issues)
	const fetchImageAsBase64 = async (url) => {
		try {
			console.log("Fetching image from URL khoj:", url);

			// Use a proxy if needed
			const proxyUrl = "https://api.allorigins.win/raw?url=";
			const response = await fetch(proxyUrl + encodeURIComponent(url));

			if (!response.ok) {
				throw new Error(`Failed to fetch image. Status: ${response.status}`);
			}

			const blob = await response.blob();
			return new Promise((resolve) => {
				const reader = new FileReader();
				reader.onloadend = () => resolve(reader.result);
				reader.readAsDataURL(blob);
			});
		} catch (error) {
			console.error("Error fetching image khoj:", error.message);
			return "/path/to/default-avatar.png"; // Fallback image
		}
	};

	return (
		<>
			{loading ? (
				<div className="mt-6 d-flex justify-content-center">
					<p>Loading...</p>
				</div>
			) : isError ? (
				<div className="mt-6 d-flex justify-content-center">
					<img src={error} alt="404 Not Found" width={300} />
				</div>
			) : (
				<>
					<div className="profile-resume-main-container pt-3">

						<div className="profile-resume-heading-cont ">
							<h4 className="orange-title">
								<span className="orange-box me-2"></span>
								Resume
							</h4>
						</div>

						{/* || userCertification?.length === 0 || userAwards?.length === 0 || userSkill?.length === 0 ||
							projectData?.length === 0 */}

						{UserType === 'Candidate' || UserType === 'Institution' ? (
							<>
								{(userEducation?.length === 0 && userExperience?.length === 0 && userAwards?.length === 0 && projectData?.length === 0 && userSkill?.length === 0) ? (
									<div className="tf-btn complete-profile-Btn mb-3">
										{/* Warning: Please complete candidate info. */}
										Profile Incomplete
									</div>
								) : ""}
							</>
						) : ""}


						<div className="profile-resume-userinfo mb-3">
							<div className="row pt-4 pb-4 align-center">
								<div className="col-md-3 col-lg-2">
									<div className="profile-resume-image d-flex ">
										<img src={userDataInfo.userImage} alt="User Logo" srcset="" width={"120px"} style={{ borderRadius: "50%", height: "120px" }} />
									</div>
								</div>
								<div className="col-md-6 col-lg-7">
									<div className="profile-resume-designation f-14 f-600">
										{userDataInfo.headLine}
									</div>
									<div className="d-flex align-items-center mb-1 Main-resume-username">
										<div className="profile-resume-username me-2">
											{userDataInfo.fullName}
										</div>
									</div>
									<div className="d-flex Resume-Skills-Country-Mobile">

										<div className="profile-resume-country d-flex align-items-center">
											{userDataInfo.currentCity === null ? "" : (
												<>
													<div className="profile-resume-country-icon d-flex  align-item-center me-3 f-18  f-400">
														<span class="icon-map-pin me-2"></span>
														{userDataInfo.currentCity}
													</div>
												</>
											)}

										</div>
									</div>
								</div>
								<div className="col-md-2 col-lg-3 Manage-Download-Mobile d-flex flex-column align-center">
									{CandidateId === 'Candidate' ? <Checkbtn /> : ''}

									<div className="edit-profile-btn  ">
										{/* {UserType === 'Company' || UserType === 'Recruiter' ? '' :
												<Link to={`/Resume/${InstnCnddtId === null ? 'Candidate' : InstnCnddtId}/Manage`} style={{ fontWeight: 'normal' }}>		
													<Button className="f-13 mt-2" style={{ width: '160px' }}>
															Manage Resume
													</Button>
												</Link>
											} */}
										{(UserType === 'Candidate' || userInstUID === userDataInfo?.insttnUID) && 
                                          (UserType !== 'Company' && UserType !== 'Recruiter') &&(
											<Link
												to={`/Resume/${InstnCnddtId || 'Candidate'}/Manage`}
												style={{ fontWeight: 'normal' }}
											>
												<Button className="f-13 mt-2" style={{ width: '160px' }}>
													Manage Resume
												</Button>
											</Link>
										)}

									</div>

									{UserType === 'Institution' || UserType === 'Recruiter' || UserType === 'Candidate' || UserType === 'Company' ? (
										<>
											{(userDataInfo?.length === 0 || userEducation?.length === 0 && userExperience?.length === 0 &&
												userCertification?.length === 0 && userSkill?.length === 0 && projectData?.length === 0 &&
												userAwards?.length === 0) ? (
												""
											) :
												<button
													type="button"
													className="f-13 f-500 mt-2 downloadbtn khojPrimaryBtn"
													onClick={downloadResume}
													disabled={isDownloading} // Disable button while downloading
													style={{
														width: "160px",
														cursor: isDownloading ? "not-allowed" : "pointer",
														backgroundColor: isDownloading ? "grey" : "",
														opacity: isDownloading ? 0.6 : 1
													}}
												>
													{isDownloading ? "Downloading..." : "Download"}
												</button>
											}
										</>
									) :
										""
									}

									{/* <button
										type="button"
										className="f-13 f-500 mt-2 downloadbtn khojPrimaryBtn"
										onClick={downloadResume}
										disabled={isDownloading} // Disable button while downloading
										style={{
											width: "160px",
											cursor: isDownloading ? "not-allowed" : "pointer",
											backgroundColor: isDownloading ? "grey" : "",
											opacity: isDownloading ? 0.6 : 1
										}}
									>
										{isDownloading ? "Downloading..." : "Download"}
									</button> */}



								</div>
							</div>
						</div>

						<div className="row d-flex justify-content-center m-auto" style={{ width: '100%' }}>
							{userDataInfo?.email === null ? (
								""
							) : (
								<>
									<div className="col-lg-4 Section-Card-Contact-D ps-4 pb-2">

										<div className=" mt-4 mb-2">
											<h6 className="profile-resume-about-heading f-20  f-800 mb-1">Basic Info</h6>
										</div>
										{userDataInfo?.email === null ? (
											""
										) : (
											<div className="content persnol-info mt-2">
												<div className="d-flex f-14">
													<AttachEmailSharpIcon className="me-2" />
													{/* <p className='mb-0'>{userDataInfo.email}</p> */}
													<a href={`mailto:${userDataInfo.email}`}
														onClick={(e) => {
															if (!userDataInfo.email) {
																e.preventDefault();
																alert("Email is not available!");
															}
														}}
													>
														{userDataInfo.email}
													</a>
												</div>
											</div>
										)}
										{userDataInfo?.dob === null ? (
											""
										) : (
											<div className="content  mt-2">
												<div className="d-flex f-14">
													<CalendarMonthSharpIcon className="me-2" /> <p className='mb-0'>
														{moment(userDataInfo.dob).format("DD MMM YYYY")}
													</p>
												</div>
											</div>
										)}
										{userDataInfo?.gender === null ? (
											""
										) : (
											<div className="content  mt-2">
												<div className="d-flex f-14">
													<WcSharpIcon className="me-2" /> <p className='mb-0'>
														{userDataInfo.gender}
													</p>
												</div>
											</div>
										)}
										{userDataInfo?.webSiteLink === '' || userDataInfo?.webSiteLink === null ? (
											""
										) : (
											<div className="content  mt-2">
												<div className="d-flex f-14">
													<LinkSharpIcon className="me-2" />
													{/* <a href={userDataInfo.webSiteLink} className="mb-0" target="_blank" rel="noopener noreferrer">
														{userDataInfo.webSiteLink}
													</a> */}
													<a
														href={userDataInfo.webSiteLink ? userDataInfo.webSiteLink.startsWith("http") ? userDataInfo.webSiteLink : `https://${userDataInfo.webSiteLink}` : "#"}
														onClick={(e) => {
															if (!userDataInfo.webSiteLink) {
																e.preventDefault();
																alert("Website is not available!");
															}
														}}
														target="_blank"
														rel="noopener noreferrer"
													>
														{userDataInfo.webSiteLink || "N.A."}
													</a>
												</div>
											</div>
										)}
										{userDataInfo?.languages?.length > 0 ? (
											<div className="content  mt-2">
												<div className="d-flex f-14">
													<LanguageSharpIcon className="me-2" />
													{/* {userDataInfo.languages.map((language, index) => (
														<p key={index} className="me-2 mb-0">
															{language}
														</p>
													))} */}
													<p className="mb-0">
														{userDataInfo.languages.join(", ")}
													</p>
												</div>
											</div>
										) : (
											""
										)}
										{userAwards?.length === 0 ? (
											""
										) : (
											<>
												<div className="profile-resume-education mt-3">
													<div className="profile-resume-about-heading f-20  f-800 mb-1">
														Awards
													</div>
													{filteredAwards.length === 0 ? "No Records , Add Award" : (
														<>
															{filteredAwards?.map((item, index) => (
																<div key={item.id || index} className="d-flex">
																	<div className="profile-resume-verticle-line me-4"></div>
																	<div>
																		<ul className='m-0 p-0'>
																			<li className='list-disc'>
																				<div className="profile-resume-education-details mb-2">
																					<div className="profile-resume-university f-14 f-700">
																						{item.name}{item.cityName === null ? '' : (
																							<span className='ms-1 f-13 f-400'> (At {item.cityName})</span>
																						)}<span className='ms-1 f-13 f-400'>{item.issueDate === null ? "" : (
																							<>
																								({moment(item.issueDate).format("DD MMM YYYY")})
																							</>
																						)}
																						</span>
																					</div>
																					<div className="profile-resume-education-designation-info f-13 f-600">
																						{item.orgName} <span className='f-400'>{item.recognition === "" ? "" : (
																							<>
																								({item.recognition})
																							</>
																						)}</span>
																					</div>
																					<div className="profile-resume-education-designation-info f-13 f-400">
																						{item.description}
																					</div>
																				</div>
																			</li>
																		</ul>

																	</div>
																</div>
															))}
														</>
													)}

												</div>
											</>
										)}
										{userSkill?.length === 0 ? (
											""
										) : (
											<>
												<div className="profile-resume-education mt-2">
													<div className="profile-resume-about-heading f-20  f-800 mb-1">
														Skills
													</div>
													{userSkill && userSkill
														.filter((item) => !item.isDeleted)
														.map((item, index) => (
															<div key={item.id || index} className="d-flex">
																<div className="profile-resume-verticle-line me-4"></div>
																<div>
																	<ul className='m-0 p-0'>
																		<li className='list-disc'>
																			<div className="profile-resume-education-details">
																				<div className="profile-resume-university f-14 f-600">
																					{item.skillName} <span className='ms-1 f-13 f-400'>
																						{item.skillName === null ? '' : (
																							<>
																								({item.fiName})
																							</>
																						)}
																					</span>
																				</div>
																			</div>
																		</li>
																	</ul>

																</div>
															</div>
														))}

												</div>
											</>
										)}
										{projectData?.length === 0 ? (
											""
										) : (
											<>
												<div className="profile-resume-education mt-2">
													<div className="profile-resume-about-heading f-20  f-800 mb-1">
														Projects
													</div>
													{filtereprojectData.length === 0 ? "No Records , Add Project" : (
														<>
															{filtereprojectData?.map((item, index) => (
																<div key={item.id || index} className="d-flex">
																	<div className="profile-resume-verticle-line me-4"></div>
																	<div>
																		<ul className='m-0 p-0'>
																			<li className='list-disc'>
																				<div className="profile-resume-education-details mb-">
																					<div className="profile-resume-university f-14 f-700">
																						{item.name} <span className='ms-1 f-13 f-400'>
																							{item.startYear === '' ? "" : (
																								<>
																									({moment(item.startMonth).format("MMM")} {moment(item.startYear).format("YYYY")})
																								</>
																							)}
																							{item.endYear === null || item.endYear === "Invalid date" ? "- Currently working on " : (
																								<>
																									- ({moment(item.endMonth).format("MMM")} {moment(item.endYear).format("YYYY")})
																								</>
																							)}
																						</span>
																					</div>
																					<div className="profile-resume-education-designation-info f-13 f-600">
																						{item.associatedWith} <span className='f-400'>{item.projectUrl === "" ? '' : (<>({item.projectUrl}) </>)} </span>
																					</div>
																					<div className="profile-resume-education-designation-info f-13 f-400">
																						{item.description}
																					</div>
																				</div>
																			</li>
																		</ul>

																	</div>
																</div>
															))}
														</>
													)}

												</div>
											</>
										)}
									</div>
								</>
							)
							}
							{userDataInfo?.length === 0 ? ""
								: (
									<>
										<div className="col-lg-8 pe-0 profile-card-two-mobile">
											<div className="profile-resume-parent-cont p-4 rounded-3">
												<div className="profile-resume-about mb-2">
													<>
														<div className="profile-resume-about-heading f-20  f-800 ">
															About
														</div>

														<div className="profile-resume-about-info mb-2">
															{userDataInfo.about === null || userDataInfo.about === "" ? "N.A" : (
																<p className="f-16 f-400 ">
																	{userDataInfo.about}
																</p>

															)}
														</div>
														<div className="profile-resume-about-info">
															{userDataInfo.currentlyActiveAsName === null || userDataInfo.currentlyActiveAsName === "" ? "N.A" : (
																<p className="f-16 f-400 mb-0">
																	<strong>Active As : </strong>{userDataInfo.currentlyActiveAsName}
																</p>

															)}
														</div>
														<div className="profile-resume-about-info">
															{userDataInfo.orgName === null || userDataInfo.orgName === "" ? "" : (
																<p className="f-16 f-400 mb-0">
																	<strong>Organization : </strong>
																	{userDataInfo.orgName === null ? "N.A" : userDataInfo.orgName}
																</p>

															)}
														</div>

														<div className="profile-resume-about-info">
															{userDataInfo.dsgntnName === null || userDataInfo.dsgntnName === "" ? "" : (
																<>
																	<p className="f-16 f-400 mb-0">
																		<strong>Designation : </strong>
																		{userDataInfo.dsgntnName === null ? "N.A" : userDataInfo.dsgntnName}
																		{/* {userDataInfo.dsgntnName === null || userDataInfo.dsgntnName === "" ? "N.A"} */}
																	</p>
																</>

															)}
														</div>


													</>
												</div>
												{userEducation?.length === 0 ? (
													""
												) : (
													<>
														<div className="profile-resume-education">
															<div className="profile-resume-about-heading f-20 f-800 mb-1">
																Education
															</div>
															{filteredEducation.length === 0 ? "No Records , Add Education" : (
																<>
																	{filteredEducation?.map((item) => (
																		<div className="d-flex mb-2" key={item.usrDataEductnId}>
																			<div className="profile-resume-verticle-line me-4"></div>
																			<div>
																				<div className="profile-resume-education-details mb-2">
																					<ul className="m-0 p-0">
																						<li className="list-disc">
																							<div className="profile-resume-university f-16 f-700">
																								{item.institutionName}
																								<span className="ms-1 f-13 f-400">
																									{item.cityName === null ? "" : `(At ${item.cityName})`}
																								</span>
																								<span className="ms-1 f-500">
																									{item.startYear === ""
																										? ""
																										: `(${moment(item.startMonth).format("MMM")} ${moment(item.startYear).format("YYYY")})`}

																									{item.isPresent ? "- Present  " : ` 
																							- (${moment(item.endMonth).format("MMM")} ${moment(item.endYear).format("YYYY")})`}

																									{/* ({moment(item?.startDate).format("DD MMM YYYY")})
																							{item.endYear === null || item.endYear ==="" ? " - Present" : (
																								<>
																									-  ({moment(item?.endDate).format("DD MMM YYYY")})
																								</>
																							)} */}
																								</span>
																							</div>
																							<div className="profile-resume-education-designation-info f-14 f-600">
																								{item.qualification}
																								<span className="f-500">
																									{item.specilization === null ? "" : ` (${item.specilization})`}
																								</span>
																							</div>
																							<div className="profile-resume-education-designation-info f-14 f-400">
																								{item.description}
																							</div>
																						</li>
																					</ul>
																				</div>

																				{/* Education Activities Section */}
																				{item.usrDataEducationActivities?.length > 0 && (
																					<div className="profile-resume-education">
																						<div className="profile-resume-about-heading f-14 f-800 mb-1">
																							<span className="border-bottom1">Education Activity</span>
																						</div>
																						{item.usrDataEducationActivities
																							.filter((activity) => !activity.isDeleted)
																							.map((activity) => (
																								<div className="d-flex" key={activity.id}>
																									<div className="profile-resume-verticle-line me-4"></div>
																									<div>
																										<div className="profile-resume-education-details">
																											<ul className="m-0 p-0">
																												<li className="list-disc f-14">{activity.activity}</li>
																											</ul>
																										</div>
																									</div>
																								</div>
																							))}
																					</div>
																				)}

																				{/* Education Achievements Section */}
																				{item.usrDataEducationAchievements?.length > 0 && (
																					<div className="profile-resume-education">
																						<div className="profile-resume-about-heading f-14 f-800 mb-1">
																							<span className="border-bottom1">Education Achievement</span>
																						</div>
																						{item.usrDataEducationAchievements
																							.filter((achievement) => !achievement.isDeleted)
																							.map((achievement) => (
																								<div className="d-flex" key={achievement.id}>
																									<div className="profile-resume-verticle-line me-4"></div>
																									<div>
																										<div className="profile-resume-education-details">
																											<ul className="m-0 p-0">
																												<li className="list-disc f-14">
																													{achievement.achievement}
																													<span className="f-500">
																														({moment(achievement.achivementDate).format("DD MMM YYYY")})
																													</span>
																												</li>
																											</ul>
																										</div>
																									</div>
																								</div>
																							))}
																					</div>
																				)}

																			</div>
																		</div>
																	))}
																</>
															)}


														</div>

													</>
												)}

												{userExperience?.length === 0 ? (
													""
												) : (
													<>
														<div className="profile-resume-education mt-2">
															<div className="profile-resume-about-heading f-20  f-800 mb-1">
																Experience
															</div>
															{filteredExperience.length === 0 ? "No Records , Add Experience" : (
																<>
																	{filteredExperience?.map((item, index) => (
																		<div key={item.id || index} className="d-flex mb-2">
																			<div className="profile-resume-verticle-line me-4"></div>
																			<div>
																				<ul className='m-0 p-0'>
																					<li className='list-disc'>
																						<div className="profile-resume-education-details mb-2">
																							<div className="profile-resume-university f-16 f-700">
																								{item.companyName}
																								{/* {item.positionHeadline === null ? '' : (
																									<>
																										({item.positionHeadline})
																									</>
																								)} */}
																								{item.positionHeadline ? ` (${item.positionHeadline})` : ''}
																								<span className='ms-2 f-13 f-400'>
																									{item.cityName === null ? '' : (
																										<>
																											(At {item.cityName})
																										</>
																									)}

																								</span>
																							</div>
																							<div className="profile-resume-education-designation f-600 f-14">
																								{item.jobTypeName}
																								<span className='me-2 ms-1 f-14 f-400 '>
																									({moment(item?.startDate).format("DD MMM YYYY")})
																									{item.endDate === null || item.endDate === "" ? " - Present" : (
																										<>
																											-  ({moment(item?.endDate).format("DD MMM YYYY")})
																										</>
																									)}
																								</span>
																							</div>
																							{/* <div className="profile-resume-education-designation-info f-13 f-600">
																							{item.workLevelTypeName } <span className='f-400'>{item.workLocationTypeName === "" ? "" : (
																								<>
																								({item.workLocationTypeName})
																								</>
																							)}</span>
																						</div> */}
																							<div className="profile-resume-education-designation-info f-13 f-400">
																								<span className='me-2 f-14 f-700'>{item.jobTitle}</span> {item.description}
																							</div>
																						</div>
																					</li>
																				</ul>
																				{item.usrDataExperienceAchievements?.length === 0 ? (
																					""
																				) : (
																					<>
																						<div className="profile-resume-education mt-2">
																							<div className="profile-resume-about-heading f-14  f-800 mb-1">
																								<span className='border-bottom1'> Experience Achievements </span>
																							</div>
																							{item.usrDataExperienceAchievements && item.usrDataExperienceAchievements
																								.filter((item) => !item.isDeleted)
																								.map((item, index) => (
																									<div key={item.id || index} className="d-flex">
																										<div className="profile-resume-verticle-line me-4"></div>
																										<div>
																											<ul className='m-0 p-0'>
																												<li className='list-disc'>
																													<div className="profile-resume-education-details">

																														<div className="profile-resume-university f-14  ">
																															{item.achievement}<span className='ms-2  f-400'>
																																{item.achivementDate === null ? "" : (
																																	<>
																																		({moment(item.achivementDate).format("DD MMM YYYY")})
																																	</>
																																)}
																															</span>
																														</div>
																													</div>
																												</li>
																											</ul>

																										</div>
																									</div>
																								))}

																						</div>
																					</>
																				)}

																				<>
																					{item.usrDataExperienceRoles &&
																						item.usrDataExperienceRoles.filter((role) => !role.isDeleted).length > 0 && (
																							<div className="profile-resume-education">
																								<div className="profile-resume-about-heading f-14 f-800 mb-1">
																									<span className="border-bottom1"> Experience Roles </span>
																								</div>
																								{item.usrDataExperienceRoles
																									.filter((role) => !role.isDeleted)
																									.map((role, index) => (
																										<div key={role.id || index} className="d-flex">
																											<div className="profile-resume-verticle-line me-4"></div>
																											<div>
																												<ul className="m-0 p-0">
																													<li className="list-disc">
																														<div className="profile-resume-education-details">
																															<div className="profile-resume-university f-14">{role.role}</div>
																														</div>
																													</li>
																												</ul>
																											</div>
																										</div>
																									))}
																							</div>
																						)}

																				</>


																			</div>

																		</div>
																	))}
																</>
															)}
														</div>
													</>
												)}

												{userCertification?.length === 0 ? (
													""
												) : (
													<>
														<div className="profile-resume-education mt-2">
															<div className="profile-resume-about-heading f-20  f-800 mb-1">
																Certificates
															</div>
															{filteredCertification.length === 0 ? "No Records , Add Certificate" : (
																<>
																	{filteredCertification?.map((item, index) => (
																		<div key={item.id || index} className="d-flex">
																			<div className="profile-resume-verticle-line me-4"></div>
																			<div>
																				<ul className='m-0 p-0'>
																					<li className='list-disc'>
																						<div className="profile-resume-education-details mb-2">
																							<div className="profile-resume-university f-14 f-700"> {item.name} {item.cityName === null ? '' : (
																								<span className='ms-1 f-400'>(At {item.cityName})</span>
																							)}<span className='ms-1 f-13 f-400'>{item.issueDate === null ? "" : (
																								<>
																									({moment(item.issueDate).format("DD MMM YYYY")})
																								</>
																							)}  {item.expirationDate === null ? " - Present" :
																								(
																									<>
																										- ({moment(item.expirationDate).format("DD MMM YYYY")})
																									</>
																								)}
																								</span>
																							</div>
																							<div className="profile-resume-education-designation-info f-13 f-600">
																								{item.orgName}  <span className='f-400 ms-1'> {item.recognition === "" ? "" : (
																									<>
																										({item.recognition})
																									</>
																								)}</span>
																							</div>
																							<div className="profile-resume-education-designation-info f-13 f-400">
																								{item.description}
																							</div>
																						</div>
																					</li>
																				</ul>

																			</div>
																		</div>
																	))}
																</>
															)}

														</div>
													</>
												)}

											</div>
										</div>
									</>
								)}
						</div>
					</div>

				</>
			)}
		</>

	)
}

export default CandidateResume